import { License } from "../../../../common/api/decimal/common-types/manageAssets.ts";
import {
  getDaysUntilExpiration,
  getHoursUntilExpiration,
} from "../../../../common/features/asset/assetHelpers.ts";

type Duration =
  | { hasDuration: false; days: undefined; hours: undefined }
  | { hasDuration: true; days: number; hours: number };

export function getExploreDuration(asset: VST.Bridge.Asset): Duration {
  if (!asset.expirationDate || asset.expirationDate === "never") {
    return { hasDuration: false, days: undefined, hours: undefined };
  }

  const expiration = {
    expiresAt: asset.expirationDate,
  } as License;

  const days = getDaysUntilExpiration(expiration);
  const hours = getHoursUntilExpiration(expiration);

  if (days === -1 || hours === -1) {
    return { hasDuration: false, days: undefined, hours: undefined };
  }

  return {
    hasDuration: true,
    days,
    hours,
  };
}
